/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-bind */
import React from 'react';
import Slider from 'react-slick';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import css from './GalleryThumbnails.scss';
import { ICONS, ICON_COLORS } from 'Constants/items';

const GalleryThumbnails = ({
    images,
    newThumbsVariant,
    thumbsContainerClassName,
    settings,
    arrowIconSize,
    arrowIconColor,
    showArrow,
    handleThumbsContainerClick,
    direction,
    thumbClassName,
    selectedThumbClassName,
    title,
    handleItemClick,
    slideIndex,
    handleNext,
    handlePrev
}) => {
    const renderthumbsArrows = () => {
        return (
            <>
                <span className={ cx({
                    [css.thumbsArrows]: !newThumbsVariant,
                    [css.newThumbsarrows]: newThumbsVariant
                }, css.prev) }
                onClick={ handlePrev }>
                    <Icon
                        icon={ ICONS.ARROW_LEFT }
                        direction={ direction }
                        size={ arrowIconSize }
                        color={ arrowIconColor }
                    />
                </span>
                <span className={ cx({
                    [css.thumbsArrows]: !newThumbsVariant,
                    [css.newThumbsarrows]: newThumbsVariant
                }, css.next) }
                onClick={ handleNext }>
                    <Icon
                        icon={ ICONS.ARROW_RIGHT }
                        direction={ direction }
                        size={ arrowIconSize }
                        color={ arrowIconColor }
                    />
                </span>
            </>
        );
    };

    return (<div
        className={ cx(css.thumbsContainer, thumbsContainerClassName) }
        onClick={ handleThumbsContainerClick }
        data-aut-id="gallery-thumbnail">
        {(newThumbsVariant || (images.length > 1))
            && <Slider { ...settings }>
                {images.map((image, idx) => {
                    const isAkamaizedImage = image.url?.includes('.akamaized.net') || image.url?.includes('.cloudfront.net') || image.url?.includes('apollo.olx.co.id') || image.url?.includes('apollo-stg.olx.co.id');
                    const finalUrl = isAkamaizedImage ? image.url.concat(';s=82x0') : image.url;

                    return (
                        <div className={ css.thumbImageWrapper } key={ `thumb-image-${title}-${idx}` }>
                            <button
                                className={ cx(css.thumb,
                                    thumbClassName,
                                    { [cx(css.selectedThumb, selectedThumbClassName)]: slideIndex === idx }) }
                                value={ idx }
                                onClick={ handleItemClick }
                                style={ { backgroundImage: `url(${finalUrl})` } } />
                        </div>
                    );
                })}
            </Slider>
        }
        {showArrow && renderthumbsArrows()}
    </div>);
};

GalleryThumbnails.propTypes = {
    images: PropTypes.arrayOf(PropTypes.object).isRequired,
    newThumbsVariant: PropTypes.bool,
    thumbsContainerClassName: PropTypes.string,
    thumbClassName: PropTypes.string,
    selectedThumbClassName: PropTypes.string,
    settings: PropTypes.object.isRequired,
    title: PropTypes.string,
    direction: PropTypes.oneOf(['rtl', 'ltr']),
    handleItemClick: PropTypes.func,
    slideIndex: PropTypes.number,
    arrowIconSize: PropTypes.number,
    showArrow: PropTypes.bool,
    arrowIconColor: PropTypes.string,
    handleThumbsContainerClick: PropTypes.func,
    handlePrev: PropTypes.func,
    handleNext: PropTypes.func
};

GalleryThumbnails.defaultProps = {
    images: [],
    newThumbsVariant: false,
    thumbsContainerClassName: '',
    thumbClassName: '',
    selectedThumbClassName: '',
    title: '',
    direction: 'rtl',
    handleItemClick: () => { },
    slideIndex: 0,
    arrowIconSize: 20,
    showArrow: false,
    arrowIconColor: ICON_COLORS.BLACK_DISABLED,
    handleThumbsContainerClick: () => {},
    handlePrev: () => {},
    handleNext: () => {},
    settings: { }
};

export default GalleryThumbnails;
